import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { setSessionState } from "modules/auth/temporary/actions";
import { setRedirectPath } from "modules/auth/saved/actions";

export const useAuthenticate = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const needAuthenticate = () => {
    const redirectPath = location.pathname + location.search + location.hash;
    dispatch(setSessionState("inactive"));
    dispatch(setRedirectPath(redirectPath));
  };

  return { needAuthenticate };
};
